import { useState, useCallback } from 'react';
import { GridApi, GridReadyEvent, GridOptions } from 'ag-grid-community';

const useGridApi = ({ onGridReady: onGridReadyParam }: {onGridReady?: GridOptions['onGridReady']} = {}) => {
  const [gridApi, setGridApi] = useState<GridApi|null>(null);

  const onGridReady = useCallback((event: GridReadyEvent) => {
    const { api } = event;
    setGridApi(api);
    onGridReadyParam?.(event);
  }, [onGridReadyParam]);

  return {
    gridApi,
    onGridReady,
  };
};

export default useGridApi;
